import React, { memo } from 'react';
import scrollIcon from '@/pages/aigc/assets/svg/scroll-arrow.svg';
import { useAutoReleaseScrollLock } from '@/pages/aigc/pages/Agent/Home/hooks/useAutoReleaseScrollLock';
import type { TStreamingState } from '@/pages/aigc/pages/Agent/ChatPage/types/history';

// 兼容别名导出：下游 IWikiThinkCmp / CopilotThinkCmp 仍以 TStreaming 引用此类型
export type TStreaming = TStreamingState;

export type IAutoReleaseBarProps = {
  streamingState: TStreamingState;
  style: React.CSSProperties;
};
export const CopilotAutoReleaseBar = memo(({ streamingState, style }: IAutoReleaseBarProps) => {
  const { scrollToBottom, showDownArrow } = useAutoReleaseScrollLock({
    className: '.dbh-agent-copilot .dba-chat-scroll',
    streamingState,
  });

  return (
    showDownArrow && (
      <div className="dba-ic-arrow_down" onClick={scrollToBottom} style={style}>
        <img src={scrollIcon} alt="" className="dba-sub-nav-icon" />
      </div>
    )
  );
});

CopilotAutoReleaseBar.displayName = 'CopilotAutoReleaseBar';
